<template>
  <div class="form-input">
    <label class="label-input" :class="{ 'label-disabled': isDisabled }">{{
      label
    }}</label>
    <input
      type="password"
      class="input"
      @input="changeInput"
      :class="{ disabled: isDisabled }"
      :value="value"
      :disabled="isDisabled ? 1 : 0"
      v-if="isPassword"
      autocomplete="off"
    />
    <input
      type="text"
      class="input"
      @input="changeInput"
      :class="{ disabled: isDisabled }"
      :value="value"
      :disabled="isDisabled ? 1 : 0"
      v-else
      autocomplete="off"
    />
    <p :class="[hasError ? 'error' : 'no-error']">
      {{ error.esMessage }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { MessageError } from "@/business/shared/commons/validator/validatorsTypes";

export default defineComponent({
  name: "GeneralInput",
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    isPassword: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object as () => MessageError,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  setup(props, context) {
    function changeInput(event: any) {
      context.emit("update:text", event.target.value);
    }

    return { changeInput };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/generalInputStyle";
</style>